<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Dashboard',

  title: 'Dashboard'
}
</script>
